import type { IconId } from "@ads/assets";
import { Box, type NotificationIntent, ToastNotification, TopNotification, useMediaQueryContext } from "@drone-js/core";
import type { FunctionComponent, ReactNode } from "react";

export interface FloatingNotificationProps {
    visible: boolean;
    onClose: () => void;
    intent: NotificationIntent;
    icon?: IconId;
    title?: string;
    description?: ReactNode | string;
}

export const FloatingNotification: FunctionComponent<FloatingNotificationProps> = ({
    visible,
    onClose,
    intent,
    title,
    description,
    icon,
}) => {
    const context = useMediaQueryContext();

    if (context.m)
        if (!visible) return null;
        else
            return (
                <Box position="fixed" maxWidth="288px" right="24px" bottom="102px" zIndex={999} id="toast-notification">
                    <ToastNotification
                        intent={intent}
                        onClose={onClose}
                        asset={
                            icon && {
                                id: icon,
                            }
                        }
                        title={title}
                        description={description}
                        density="compact"
                        dismissible
                    />
                </Box>
            );

    return (
        <TopNotification
            visible={visible}
            onNotificationClose={onClose}
            intent={intent}
            title={title}
            leadingIcon={icon}
            // @ts-expect-error It can actually accept ReactNode, but will crash because it will try to count word. check RequirementNotMetNotification for hack
            description={description}
            zIndex={999}
            id="top-notification"
        />
    );
};
